import { Component, OnInit, Inject } from '@angular/core';
import { MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ProcedureCodesService } from 'src/app/Services/ProcedureCodes/procedure-codes.service';
import { ToastrService } from 'ngx-toastr';
import { ISnomed } from 'src/app/models/IProcedureCodes';
import { IOrdersLoinc } from 'src/app/models/ICptOrdersComponent';

@Component({
  selector: 'app-master-lab-orders',
  templateUrl: './master-lab-orders.component.html',
  styleUrls: ['./master-lab-orders.component.css']
})

export class MasterLabOrdersComponent implements OnInit {

  LabOrderMasterForm: FormGroup;
  dataSource = new MatTableDataSource();
  blue: string = '#BAFBC1';
  white: string = '#FFFFF';
  searchresults: string = "";
  ordersLoincCodes: IOrdersLoinc[] = [];
  displayedColumns: string[] = ['cptcode', 'description'];
  constructor(private formBuilder: FormBuilder, private procedureCodesService: ProcedureCodesService, private toastr: ToastrService,
    public dialogRef: MatDialogRef<MasterLabOrdersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IOrdersLoinc, public dialog: MatDialog) { }

  ngOnInit() {
    this.LabOrderMasterForm = this.formBuilder.group({
      MasterCptlist: ['']
    });
    // if (this.data != undefined && this.data.cptCode != '') {
    //   this.LabOrderMasterForm.controls["MasterCptlist"].setValue(this.data.cptCode);
    //   this.searchMasterCPTcodes();
    // }
  }

  onMasterCptSearch() {
    this.searchMasterCPTcodes();
  }

  public MasterCPTList: IOrdersLoinc[];
  searchMasterCPTcodes() {
    var searchText = this.LabOrderMasterForm.value.MasterCptlist;
    if (searchText != null && searchText != undefined && searchText != '') {
      this.procedureCodesService.getLoincCodeBySearch(searchText).subscribe(
        results => {
          this.MasterCPTList = results;
          if (results.length == 0) {
            this.searchresults = "No search results found.";
          }
          else {
            this.searchresults = "";
          }

          this.dataSource.data = this.MasterCPTList;
          // if (this.MasterCPTList.length == 1 && this.MasterCPTList[0].activeStatus == false) {
          //   this.MasterCPTList[0].activeStatus = true;
          //   this.selectedCPTCodes(0, this.MasterCPTList[0], true);
          // }
        }, (err: any) => console.log(err));
    }
  }

  public newMasterrecord: IOrdersLoinc[] = [];
  selectedCPTCodes(index, element: IOrdersLoinc, event: boolean) {
    if (event == true) {
      //this.MasterCPTList[index].background = this.blue;
      element.categoryId = 40;
      element.categoryName = 'Laboratory Orders';
      this.newMasterrecord.push(element);
    } else {
      // this.MasterCPTList[index].background = 'white';
      this.newMasterrecord = this.newMasterrecord.filter(ele => ele != element);
    }
  }

  AddCPTMaster() {
    if (this.newMasterrecord.length == 0) {
      this.toastr.error("Please select Loinc Number");
    } else {
      this.dialogRef.close(this.newMasterrecord);
    }
  }
  selectedRowIndex: number = -1;
  oncellclick(row) {
    this.selectedRowIndex = row.cptMasterId;
  }
  CancelCPTMaster() {
    this.dialogRef.close('cancel');
  }
}
// export interface DialogData {
//   headerText: string;
//   columnName: string;
// }